<template>
  <div id="addFreightTpl" class="add-freight-tpl">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toFreightManage">运费管理/</span>
        {{pageModule ? '新增' : '编辑'}}运费模板
      </template>
      <template v-slot:content>
        <div class="freight-tpl">
          <div class="tpl-name row">
            <i class="require-icon"></i>
            <span class="text">模板名称：</span>
            <el-input class="gray" type="text" v-model="tplName" placeholder="请输入模板名称"></el-input>
          </div>
          <div class="billig-method row">
            <span class="text">计费方式：</span>
            <el-radio-group v-model="billingMethod">
              <el-radio :label="billingMethods.billedByItem">按件数</el-radio>
              <el-radio :label="billingMethods.billedByAmount">按金额</el-radio>
            </el-radio-group>
          </div>
          <div class="delivery-area row">
            <span class="text">配送区域：</span>
            <div class="wrapper" ref="tableElement">
              <div class="table-container">
                <el-table
                  class="table"
                  :data="freightByPieceTpl"
                  v-show="billingMethod === billingMethods.billedByItem"
                >
                  <el-table-column label="可配送区域" :width="specialLabelWidth">
                    <template slot-scope="scope">
                      <p class="areas">{{scope.row.deliveryArea}}</p>
                      <div class="operation">
                        <span class="edit" @click="editAddress(scope, scope.row)">修改</span>
                        <span class="delete" @click="deleteAddress(scope, scope.row)">删除</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="首件（件）" :width="pieceNormalLabelWidth">
                    <template slot-scope="scope">
                      <int-input
                        class="amount"
                        :updateIndex="scope.$index"
                        :intNum="Number(scope.row.firstPiece)"
                        @update="updateIndex"
                        @complete="filterFirstAmountNum"
                      ></int-input>
                      <!-- <el-input class="gray"
                                @focus="updateIndex(scope)"
                                @change="filterFirstAmountNum"
                                v-model="scope.row.firstPiece">
                      </el-input>-->
                    </template>
                  </el-table-column>
                  <el-table-column label="运费（元）" :width="pieceNormalLabelWidth">
                    <template slot-scope="scope">
                      <decimal-input
                        class="freight"
                        :updateIndex="scope.$index"
                        :decimalNum="Number(scope.row.baseFreight)"
                        @update="updateIndex"
                        @complete="filterFirstExes"
                      ></decimal-input>
                      <!-- <el-input class="gray"
                                @focus="updateIndex(scope)"
                                @change="filterFirstExes"
                      v-model="scope.row.baseFreight"></el-input>-->
                    </template>
                  </el-table-column>
                  <el-table-column label="续件（件）" :width="pieceNormalLabelWidth">
                    <template slot-scope="scope">
                      <int-input
                        class="amount"
                        :updateIndex="scope.$index"
                        :intNum="scope.row.extraPiece"
                        @update="updateIndex"
                        @complete="filterSecondAmountNum"
                      ></int-input>
                      <!-- <el-input class="gray"
                                @focus="updateIndex(scope)"
                                @change="filterSecondAmountNum"
                      v-model="scope.row.extraPiece"></el-input>-->
                    </template>
                  </el-table-column>
                  <el-table-column label="续费（元）" :width="pieceNormalLabelWidth">
                    <template slot-scope="scope">
                      <decimal-input
                        class="freight"
                        :updateIndex="scope.$index"
                        :decimalNum="scope.row.extraFreight"
                        @update="updateIndex"
                        @complete="filterSecondExes"
                      ></decimal-input>
                      <!-- <el-input class="gray"
                                @focus="updateIndex(scope)"
                                @change="filterSecondExes"
                      v-model="scope.row.extraFreight"></el-input>-->
                    </template>
                  </el-table-column>
                </el-table>

                <el-table
                  class="table"
                  :data="freightByAmountTpl"
                  v-show="billingMethod === billingMethods.billedByAmount"
                >
                  <el-table-column label="可配送区域" :width="specialLabelWidth">
                    <template slot-scope="scope">
                      <p class="areas">{{scope.row.deliveryArea}}</p>
                      <div class="operation">
                        <span class="edit" @click="editAddress(scope, scope.row)">修改</span>
                        <span class="delete" @click="deleteAddress(scope, scope.row)">删除</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="包邮条件" :width="amountNormalLabelWidth">
                    <template slot-scope="scope">
                      金额满
                      <decimal-input
                        class="freight"
                        :updateIndex="scope.$index"
                        :decimalNum="Number(scope.row.condition)"
                        @update="updateIndex"
                        @complete="filterBaseExes"
                      ></decimal-input>
                      <!-- <el-input class="gray"
                                @focus="updateIndex(scope)"
                                @change="filterBaseExes"
                                v-model="scope.row.condition">
                      </el-input>-->
                      元即可包邮
                    </template>
                  </el-table-column>
                  <el-table-column label="运费（元）" :width="amountNormalLabelWidth">
                    <template slot-scope="scope">
                      <decimal-input
                        class="freight"
                        :updateIndex="scope.$index"
                        :decimalNum="scope.row.freight"
                        @update="updateIndex"
                        @complete="filterExtraExes"
                      ></decimal-input>
                      <!-- <el-input class="gray"
                                @focus="updateIndex(scope)"
                                @change="filterExtraExes"
                                v-model="scope.row.freight">
                      </el-input>-->
                    </template>
                  </el-table-column>
                </el-table>
                <div class="select-area-btn" @click="selectAddress">选择配送区域</div>
              </div>
              <div class="save-or-cancel">
                <div class="save-btn btn" @click="saveTpls">保存</div>
                <div class="cancel-btn btn" @click="cancelTpls">取消</div>
              </div>
            </div>
          </div>
        </div>
        <el-dialog title="地址选择" :visible.sync="showAddressSelector">
          <selector-address
            :allAddressList="allAddressList"
            :selectedAddressList="selectedAddressList"
            @saveAddress="onSaveAddress"
          ></selector-address>
        </el-dialog>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import SelectorAddress from 'base/SelectorAddress';
import IntInput from 'components/base/IntInput';
import DecimalInput from 'components/base/DecimalInput';
import DBAddress from 'models/db/address.js';
import DBCommoidty from 'models/db/commodity.js';
const dbAddress = new DBAddress();
const dbCommodity = new DBCommoidty();
const billingMethods = {
  // 按件计费
  billedByItem: 0,
  // 按金额计费
  billedByAmount: 1
};
const pageModules = {
  // 新增模板
  addNewTpl: 1,
  // 更新模板
  updateOldTpl: 0
};
export default {
  data() {
    return {
      // pageModule 1 新增 0 编辑
      pageModule: pageModules.addNewTpl,
      copy: false,
      showAddressSelector: false,
      tableWidth: 0,
      tplName: '',
      billingMethods: billingMethods,
      billingMethod: billingMethods.billedByItem,
      // 城市列表数据
      allAddressList: [],
      // 被默认选中的地址列表
      selectedAddressList: [],
      // 按件数计费
      freightByPieceTpl: [],
      // 按金额计费
      freightByAmountTpl: []
    };
  },
  computed: {
    pieceNormalLabelWidth() {
      return parseInt(this.tableWidth * 0.125, 10);
    },
    amountNormalLabelWidth() {
      return parseInt(this.tableWidth * 0.25, 10);
    },
    specialLabelWidth() {
      return parseInt(this.tableWidth * 0.5, 10);
    }
  },
  methods: {
    updateIndex(updateIndex) {
      this.currFreightTplIndex = updateIndex;
    },
    filterFirstAmountNum(val) {
      let tpl = JSON.parse(
        JSON.stringify(this.freightByPieceTpl[this.currFreightTplIndex])
      );
      tpl.firstPiece = val;
      this.freightByPieceTpl.splice(this.currFreightTplIndex, 1, tpl);
    },
    filterSecondAmountNum(val) {
      let tpl = JSON.parse(
        JSON.stringify(this.freightByPieceTpl[this.currFreightTplIndex])
      );
      tpl.extraPiece = val;
      this.freightByPieceTpl.splice(this.currFreightTplIndex, 1, tpl);
    },
    filterFirstExes(val) {
      let tpl = JSON.parse(
        JSON.stringify(this.freightByPieceTpl[this.currFreightTplIndex])
      );
      tpl.baseFreight = val;
      this.freightByPieceTpl.splice(this.currFreightTplIndex, 1, tpl);
    },
    filterSecondExes(val) {
      let tpl = JSON.parse(
        JSON.stringify(this.freightByPieceTpl[this.currFreightTplIndex])
      );
      tpl.extraFreight = val;
      this.freightByPieceTpl.splice(this.currFreightTplIndex, 1, tpl);
    },
    filterBaseExes(val) {
      let tpl = JSON.parse(
        JSON.stringify(this.freightByAmountTpl[this.currFreightTplIndex])
      );
      tpl.condition = val;
      this.freightByAmountTpl.splice(this.currFreightTplIndex, 1, tpl);
    },
    filterExtraExes(val) {
      let tpl = JSON.parse(
        JSON.stringify(this.freightByAmountTpl[this.currFreightTplIndex])
      );
      tpl.freight = val;
      this.freightByAmountTpl.splice(this.currFreightTplIndex, 1, tpl);
    },
    // 保存新增的模板
    saveTpls() {
      // 模板名称不能为空
      if (!this.tplName) {
        this.$alert('模板名字不能为空', '操作提示', {
          confirmButtonText: '确定',
          type: 'warning',
          center: true
        });
        return false;
      }
      // 模板不能为空
      if (!this.freightByPieceTpl.length && !this.freightByAmountTpl.length) {
        this.$alert('模板数据不能为空', '操作提示', {
          confirmButtonText: '确定',
          type: 'warning',
          center: true
        });
        return false;
      }
      // 先判断模板计费类型
      let costInfo = [];
      if (this.billingMethod === billingMethods.billedByItem) {
        // 按件计费
        this.freightByPieceTpl.map(item => {
          costInfo.push({
            first: item.firstPiece,
            trafficCost: item.baseFreight,
            next: item.extraPiece,
            nextTrafficCost: item.extraFreight,
            destinations: item.itsAddressList,
            destinationNames: item.deliveryArea
          });
        });
      } else if (this.billingMethod === billingMethods.billedByAmount) {
        // 按金额计费
        this.freightByAmountTpl.map(item => {
          costInfo.push({
            limit: item.condition,
            price: item.freight,
            destinations: item.itsAddressList,
            destinationNames: item.deliveryArea
          });
        });
      }
      let countStyle = this.billingMethod;
      // 判断是新增模板还是编辑模板
      if (this.pageModule) {
        // 新增
        let data = {
          name: this.tplName,
          countStyle: countStyle,
          costInfo: JSON.stringify(costInfo)
        };
        this._addFreightTpl(data);
      } else {
        // 编辑
        let tplId = this.$route.query.id;
        let data = {
          id: tplId,
          name: this.tplName,
          countStyle: countStyle,
          costInfo: JSON.stringify(costInfo)
        };
        this._updateFreightTplInfo(data);
      }
    },
    // 取消模板编辑，返回运费模板列表
    cancelTpls() {
      this.$router.push({
        path: '/admin/commodity/freight/freight-manage'
      });
    },
    // 新增地址
    selectAddress() {
      this.tplType = 'add';
      this.selectedAddressList = [];
      this.showAddressSelector = true;
    },
    // 修改地址
    editAddress(scope, freightTpl) {
      this.tplType = 'edit';
      this.selectedAddressList = freightTpl.itsAddressList;
      this.currentEditedTplIndex = scope.$index;
      this.showAddressSelector = true;
    },
    // 删除地址
    deleteAddress(scope, freightTpl) {
      let currentIndex = scope.$index;
      if (this.billingMethod === billingMethods.billedByItem) {
        // 从 piece 中删除
        this.freightByPieceTpl.splice(currentIndex, 1);
      } else if (this.billingMethod === billingMethods.billedByAmount) {
        // 从 amount 中删除
        this.freightByAmountTpl.splice(currentIndex, 1);
      }
    },
    // 返回运费模板列表
    toFreightManage() {
      this.$router.push({
        path: '/admin/commodity/freight/freight-manage'
      });
    },
    onSaveAddress(data) {
      let { selectedAddressList, selectedProOrMun } = data;
      console.log('选择的', selectedProOrMun);
      let deliveryArea = '';
      // selectedProOrMun
      selectedProOrMun.map((item, index, array) => {
        if (index !== array.length - 1) {
          deliveryArea += item + ', ';
        } else {
          deliveryArea += item;
        }
      });
      if (this.tplType === 'add') {
        // 新增运费模板
        if (this.billingMethod === billingMethods.billedByItem) {
          // 按件数
          this.freightByPieceTpl.push({
            deliveryArea: deliveryArea,
            firstPiece: 1,
            baseFreight: 0,
            extraPiece: 1,
            extraFreight: 0,
            itsAddressList: selectedAddressList
          });
        } else if (this.billingMethod === billingMethods.billedByAmount) {
          // 按金额
          this.freightByAmountTpl.push({
            deliveryArea: deliveryArea,
            condition: 0,
            freight: 0,
            itsAddressList: selectedAddressList
          });
        }
      } else if (this.tplType === 'edit') {
        // 修改原来的运费模板
        let updateTpl;
        if (this.billingMethod === billingMethods.billedByItem) {
          // 按件数
          updateTpl = this.freightByPieceTpl[this.currentEditedTplIndex];
          updateTpl = Object.assign(updateTpl, {
            billingMethod: billingMethods.billedByItem,
            deliveryArea: deliveryArea,
            itsAddressList: selectedAddressList
          });
          this.freightByPieceTpl.splice(
            this.currentEditedTplIndex,
            1,
            updateTpl
          );
        } else if (this.billingMethod === billingMethods.billedByAmount) {
          // 按金额
          updateTpl = this.freightByAmountTpl[this.currentEditedTplIndex];
          updateTpl = Object.assign(updateTpl, {
            billingMethod: billingMethods.billedByItem,
            deliveryArea: deliveryArea,
            itsAddressList: selectedAddressList
          });
          this.freightByAmountTpl.splice(
            this.currentEditedTplIndex,
            1,
            updateTpl
          );
        }
      }
      // 隐藏地址选择器
      this.showAddressSelector = false;
    },
    // 获取城市列表
    _getAddressList() {
      dbAddress.getDBAddressMock().then(res => {
        this.allAddressList = res;
      });
    },
    // 新增运费模板
    _addFreightTpl(data) {
      dbCommodity
        .addFreightTpl(data)
        .then(res => {
          if (res.success) {
            this.$router.push({
              path: '/admin/commodity/freight/freight-manage'
            });
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: 'error',
              duration: 1000
            });
          }
        })
        .catch(e => {
          console.log('新增运费模板异常--', e);
        });
    },
    // 更新运费模板
    _updateFreightTplInfo(data) {
      dbCommodity
        .updateFreightTplInfo(data)
        .then(res => {
          if (res.success) {
            this.$router.push({
              path: '/admin/commodity/freight/freight-manage'
            });
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: 'error',
              duration: 1000
            });
          }
        })
        .catch(e => {
          console.log('更新异常--', e);
        });
    },
    // 获取已有的模板信息
    _getFreightTplInfoById(tplId) {
      dbCommodity
        .getFreightTplInfoById(tplId)
        .then(res => {
          if (res.success) {
            let tplInfo = res.result;
            if (this.copy) {
              this.tplName = tplInfo.name + '-copy';
            } else {
              this.tplName = tplInfo.name;
            }
            this.billingMethod = tplInfo.countStyle;
            let tplInfoList = JSON.parse(tplInfo.costInfo);
            if (this.billingMethod === billingMethods.billedByAmount) {
              // 按金额
              tplInfoList.map(item => {
                this.freightByAmountTpl.push({
                  condition: item.limit,
                  freight: item.price,
                  itsAddressList: item.destinations,
                  deliveryArea: item.destinationNames
                });
              });
            } else if (this.billingMethod === billingMethods.billedByItem) {
              // 按件数
              tplInfoList.map(item => {
                this.freightByPieceTpl.push({
                  firstPiece: item.first,
                  baseFreight: item.trafficCost,
                  extraPiece: item.next,
                  extraFreight: item.nextTrafficCost,
                  itsAddressList: item.destinations,
                  deliveryArea: item.destinationNames
                });
              });
            }
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: 'error',
              duration: 1000
            });
          }
        })
        .catch(e => {
          console.log('异常--', e);
        });
    }
  },
  created() {
    let tplId = this.$route.query.id;
    let copy = this.$route.query.copy;
    if (tplId) {
      // 编辑--根据tplId获取模板信息
      if (copy) {
        this.pageModule = 1;
        this.copy = true;
        this._getFreightTplInfoById(tplId);
      } else {
        this.pageModule = 0;
        this._getFreightTplInfoById(tplId);
      }
    } else {
      // 新增
      this.pageModule = 1;
    }
    this._getAddressList();
  },
  mounted() {
    this.tableWidth = this.$refs.tableElement.clientWidth - 32;
  },
  components: {
    SecondMenuLinkContent,
    SelectorAddress,
    IntInput,
    DecimalInput
  }
};
</script>

<style lang="scss" scoped>
.add-freight-tpl {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .freight-tpl {
    display: flex;
    flex-direction: column;
    .row {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .text {
        font-size: 14px;
        font-family: "PingFangSC-Regular";
        font-weight: 400;
        color: rgba(96, 98, 102, 1);
        margin-right: 6px;
        flex-shrink: 0;
      }
    }
    .tpl-name {
      .require-icon {
        width: 10px;
        height: 10px;
        background: url("../../../../assets/commodity/required.png");
        background-size: 10px 10px;
      }
      .gray {
        width: 320px;
      }
    }
    .billig-method {
      padding-left: 10px;
      margin: 20px 0;
    }
    .delivery-area {
      padding-left: 10px;
      align-items: flex-start;
      .wrapper {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .table-container {
          /* 包裹表格的容器 */
          background: skyblue;
          padding: 16px;
          background: rgba(224, 231, 255, 0.2);
          .table {
            /* 表格主体 */
            .areas {
              font-size: 14px;
              font-family: "PingFangSC-Regular";
              font-weight: 400;
              color: rgba(96, 98, 102, 1);
              margin-right: 132px;
              width: 400px;
            }
            .operation {
              width: 200px;
              font-size: 14px;
              font-family: "PingFangSC-Regular";
              font-weight: 400;
              display: flex;
              flex-direction: row;
              color: rgba(61, 116, 242, 0.75);
              &:hover {
                color: rgba(61, 116, 242, 1);
              }
              .edit {
                cursor: pointer;
                margin-right: 16px;
              }
              .delete {
                cursor: pointer;
              }
            }
            .amount,
            .freight {
              width: 100px;
            }
          }
          .select-area-btn {
            margin-top: 16px;
            width: 128px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: rgba(61, 116, 242, 1);
            border-radius: 4px;
            font-size: 14px;
            font-family: "PingFangSC-Regular";
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            cursor: pointer;
            &:hover {
              background: rgba(61, 116, 242, 0.75);
            }
          }
        }
        .save-or-cancel {
          margin-top: 16px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          .btn {
            width: 96px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border-radius: 4px;
            font-size: 14px;
            font-family: "PingFangSC-Regular";
            font-weight: 400;
            cursor: pointer;
          }
          .save-btn {
            margin-right: 16px;
            color: rgba(255, 255, 255, 1);
            background: rgba(61, 116, 242, 1);
            &:hover {
              background: rgba(61, 116, 242, 0.75);
            }
          }
          .cancel-btn {
            color: rgba(61, 116, 242, 1);
            border: 1px solid rgba(61, 116, 242, 1);
          }
        }
      }
    }
  }
  .selector-address {
    width: 100%;
    height: 600px;
    overflow: auto;
    .operation {
      height: 32px;
      font-size: 16px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .desc {
        .select-number {
          color: rgba(61, 116, 242, 1);
        }
      }
      .btn-white {
        color: rgba(255, 255, 255, 1);
        border-radius: 4px;
        padding: 8px 10px;
        background: rgba(61, 116, 242, 0.75);
        cursor: pointer;
        &:hover {
          background: rgba(61, 116, 242, 1);
        }
      }
    }
  }
}
</style>

<style lang="scss">
#addFreightTpl {
  .el-table {
    .el-table__header {
      .has-gutter {
        tr {
          th {
            padding: 4px 0;
            opacity: 0.75;
            background: rgba(234, 238, 245, 1);
            .cell {
              color: #606266;
              height: 24px;
            }
          }
        }
      }
    }
    .el-table__body {
      tbody {
        tr {
          td {
            padding: 0;
            .cell {
              display: flex;
              justify-content: flex-start;
              align-items: center;
            }
          }
          td:first-child {
            .cell {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              padding: 16px;
            }
          }
        }
      }
    }
  }
  .el-tree {
    .el-tree-node {
      .el-tree-node__content {
        height: 32px;
      }
    }
  }
}
</style>
